import { ChangeEvent } from "react";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { DCUIContent, DCUIContentValidation } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { DCUIThemingTextContentValidationErrors } from "@idw-types/common/validation/common/dcui-theming-validation-errors";
import { InputFormGroup } from "../../../../../common/input-form-group/input-form-group";
import { ThemingFormGroupWrapper } from "@containers/common/theming-input-form-group/theming-form-group-wrapper";
import { PageLevelTypes } from "@enums/page-level-types";

type DCUIThemingTextContentValidationGeneralSectionProps = {
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    dcuiContent: DCUIContent;
    inheritedDCUIContent: DCUIContent;
    pageLevel: PageLevelTypes;
    validationErrors: DCUIThemingTextContentValidationErrors;
    updateDCUIContentValidationFieldValue: (key: keyof DCUIContentValidation, value: string) => void;
};

export const DCUIThemingTextContentValidationGeneralSection = (props: DCUIThemingTextContentValidationGeneralSectionProps) => {
    const {
        layout,
        labelWidth,
        isDisabled,
        dcuiContent,
        inheritedDCUIContent,
        pageLevel,
        validationErrors,
        updateDCUIContentValidationFieldValue
    } = props;

    const handleValidationTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateDCUIContentValidationFieldValue("validationTitle", event.target.value);
    };

    const handleResetValidationTitle = () => {
        updateDCUIContentValidationFieldValue("validationTitle", inheritedDCUIContent.validation.validationTitle);
    };

    const handleValidationLoadingTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateDCUIContentValidationFieldValue("validationLoadingText", event.target.value);
    };

    const handleResetValidationLoadingText = () => {
        updateDCUIContentValidationFieldValue("validationLoadingText", inheritedDCUIContent.validation.validationLoadingText);
    };

    const validationGeneralResources = resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.textContent.sections.validation.sections.general;

    return (
        <div>
            <ThemingFormGroupWrapper
                inheritedThemingPropertyValue={inheritedDCUIContent.validation.validationTitle}
                currentThemingPropertyValue={dcuiContent.validation.validationTitle}
                pageLevel={pageLevel}
                
            >
                <InputFormGroup
                    controlId={"document-capture-text-content-validation-title-input"}
                    automationId={"document-capture-text-content-validation-title-input"}
                    label={validationGeneralResources.inputs.title.label}
                    ariaLabel={validationGeneralResources.inputs.title.label}
                    layout={layout}
                    labelWidth={labelWidth}
                    onChange={handleValidationTitleChange}
                    value={dcuiContent.validation.validationTitle || ""}
                    disabled={isDisabled}
                    isRequired={true}
                    afterLabelTooltipText={validationGeneralResources.inputs.title.tooltip}
                    afterLabelIcon={isDisabled ? null : faUndo}
                    afterLabelIconOnClick={handleResetValidationTitle}
                />
            </ThemingFormGroupWrapper>
            {validationErrors.validationTitleError}
            <ThemingFormGroupWrapper
                inheritedThemingPropertyValue={inheritedDCUIContent.validation.validationLoadingText}
                currentThemingPropertyValue={dcuiContent.validation.validationLoadingText}
                pageLevel={pageLevel}
            >
                <InputFormGroup
                    controlId={"document-capture-text-content-validation-loading-text-input"}
                    automationId={"document-capture-text-content-validation-loading-text-input"}
                    label={validationGeneralResources.inputs.loadingText.label}
                    ariaLabel={validationGeneralResources.inputs.loadingText.label}
                    layout={layout}
                    labelWidth={labelWidth}
                    onChange={handleValidationLoadingTextChange}
                    value={dcuiContent.validation.validationLoadingText || ""}
                    disabled={isDisabled}
                    isRequired={true}
                    afterLabelTooltipText={validationGeneralResources.inputs.loadingText.tooltip}
                    afterLabelIcon={isDisabled ? null : faUndo}
                    afterLabelIconOnClick={handleResetValidationLoadingText}
                />
            </ThemingFormGroupWrapper>
            {validationErrors.validationLoadingTextError}
        </div>
    );
};